var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SettingGroup',{attrs:{"title":"ロックするキーリスト"}},[_c('div',{staticClass:"transferWrapper"},[(_vm.isReady)?_c('Transfer',{attrs:{"transferData":_vm.transferOptions,"initialSelected":_vm.form.keyList,"leftPanelTitle":"ロックするキーリスト","rightPanelTitle":"選択可能な機能"},on:{"select":_vm.handleSelected}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }